// Central commercial configuration — edit prices, links and visuals here.
// Buttons inside the offer, guarantee and closing sections send buyers to checkoutUrl.
// Top and mid-page buttons scroll to the #offer section.
export const offer = {
  productName: "WHY WE BELIEVE",
  productSubtitle: "The Kids' Faith Mega Bundle",
  price: "$27",
  regularPrice: "$97",
  savings: "$70",
  currency: "USD",
  checkoutUrl: "https://why-we-believe-the-kids-faith-mega-bundle.impultienda.ar/checkout",
  supportEmail: "",
};

export const ctaMicrocopy = {
  hero: ["One-Time Payment", "Instant Digital Access", "7-Day Guarantee"],
  mid: ["Instant Access", "One-Time Payment", "7-Day Guarantee"],
  offer: ["One-Time Payment", "No Subscription", "Instant Digital Access"],
  closing: ["Instant Digital Access", "One-Time Payment", "7-Day Money-Back Guarantee"],
};

// Leave href empty until the page exists — empty links render as plain text.
export const legalLinks = [
  { label: "Contact Us", href: "" },
  { label: "Privacy Policy", href: "" },
  { label: "Terms of Service", href: "" },
  { label: "Refund Policy", href: "" },
];

// Final product mockups — paste an image URL to replace the coded collection mockup.
export const productVisuals = {
  heroMockup:
    "https://cdn.magicpatterns.com/uploads/unXJuWBZbJFdTyZpCWmihK/Libro,_tablet_y_seis_volumenes_en_3D.png",
  offerMockup:
    "https://cdn.magicpatterns.com/uploads/8oGYFdhZx6FPpSrDhSHtqe/Cinco_guias_de_fe_con_portadas_distintas.png",
};
